const handle = {
  handleVisionItemData: (data) => {
    const { left_eye, right_eye, left_eye_type, right_eye_type, presby_status, colour_blind_status } = data.info;
    return {
      left_eye: left_eye ? left_eye : 0,
      right_eye: right_eye ? right_eye : 0,
      left_eye_type: left_eye_type ? left_eye_type : 0,
      right_eye_type: right_eye_type ? right_eye_type : 0,
      presby_status: presby_status ? presby_status : 0,
      colour_blind_status: colour_blind_status ? colour_blind_status : 0,
    };
  }
};
export default handle;
